const statusItems = [
  {
    key: 'ALL_TIME',
    label: 'Semua',
  },
  {
    key: 'DRAFT|CONFIRMED',
    label: 'Draf dan Dikonfirmasi',
  },
]

export default statusItems
